import { render, staticRenderFns } from "./BoxInfoPatient.vue?vue&type=template&id=7273a0e4&scoped=true&"
import script from "./BoxInfoPatient.vue?vue&type=script&lang=js&"
export * from "./BoxInfoPatient.vue?vue&type=script&lang=js&"
import style0 from "./BoxInfoPatient.vue?vue&type=style&index=0&id=7273a0e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7273a0e4",
  null
  
)

export default component.exports